<template>
    <div v-if="currentSegmentIndex != null">
       <div class="navigation-window">
            <div class="icons">
                <fa :icon="['far', 'circle-left']" size="lg" class="prev fa-1-5x" :class="{'disabled': isPrevDisabled}" @click="!isPrevDisabled && nextPrevANSISegment(false)" title="Previous Segment"/>
                <fa :icon="['fas', 'search']" size="1x" class="last" :class="{'disabled': !hasPrevAnsiSegment()}" title="Last Segment" @click="lastANSISegment()"/>
                <fa :icon="['far', 'circle-right']" size="lg" class="next fa-1-5x" :class="{'disabled': isNextDisabled}" @click="!isNextDisabled && nextPrevANSISegment(true)" title="Next Segment"/>
                <MMP_ANSI_LayerShortcuts
                  v-if="btnLabels.length > 0 && btnLayers && layerDefinition != 'BIASED'"
                  :btnLabels="btnLabels"
                  :btnLayers="btnLayers"
                  :activeLayers="map.getLayers().getArray()"
                  :ansiLayersButtonCtrl="ansiLayersButtonCtrl"
                  @toggleLayer="$emit('toggleLayer', $event)"
                />
            </div>
        </div>
        <div class="segment-label-window" :class="getSegmentLabelClass()" id="segment_label">
            <div>SEGMENT ID = {{ ansiSegments[currentSegmentIndex].ansi_id }}</div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import MMP_ANSI_LayerShortcuts from './MMP_ANSI_LayerShortcuts.vue'
export default {
  name: 'MMP_ANSI_Navigation',
  props: [
    'ansiLayersButtonCtrl',
    'map',
    'customerProjectId',
    'layerDefinition',
    'apiUrl',
    'currentANSIPartNumber'
  ],
  components: {
    MMP_ANSI_LayerShortcuts
  },
  data() {
    return {
        isPrevDisabled: true,
        isNextDisabled: false,
        ansiSegments: [],
        currentSegmentIndex: null,
        btnLabels: [],
        btnLayers: {}
    }
  },
  methods: {
    nextPrevANSISegment(bool) {
        this.$emit('closeAnsiTestingWindow')

        let newIndex = bool ? this.currentSegmentIndex + 1 : this.currentSegmentIndex - 1

        this.saveEndTimeForAnsi(this.ansiSegments[this.currentSegmentIndex])
        this.saveStartTimeForAnsi(this.ansiSegments[newIndex])

        // Get coords for next segment
        let x  = this.ansiSegments[newIndex].x
        let y  = this.ansiSegments[newIndex].y

        this.$emit('ansiSegmentChange', [x, y])
        this.$emit('setSpeedLimit', this.ansiSegments[newIndex])

        sessionStorage.setItem('prevAnsiSegment', JSON.stringify(this.ansiSegments[this.currentSegmentIndex]))

        this.currentSegmentIndex = newIndex
    },
    saveEndTimeForAnsi(data) {
        if (sessionStorage.token) {
            if (data) {
                axios
                .get(
                    process.env.API_LOCATION + '/api/' + this.apiUrl + '/saveEndTimeForAnsi/',
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'x-auth-token': sessionStorage.token
                        },
                        params: {
                            partNumber: this.currentANSIPartNumber.part_number,
                            segmentId: data.ansi_id
                        }
                    }
                )
                .catch(function (error) {
                    console.log(error)
                })
            } else {
                console.log('Error saving end time for Ansi Segment - no data available')
            }
        } else {
            this.$router.push({name: 'Login'})
        }
    },
    saveStartTimeForAnsi(data) {
        if (sessionStorage.token) {
            if (data) {
                axios
                .get(
                    process.env.API_LOCATION + '/api/' + this.apiUrl + '/saveStartTimeForAnsi/',
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'x-auth-token': sessionStorage.token
                        },
                        params: {
                            partNumber: this.currentANSIPartNumber.part_number,
                            segmentId: data.ansi_id,
                            selset: data.selset
                        }
                    }
                )
                .catch(function (error) {
                    console.log(error)
                })
            } else {
                console.log('Error saving start time for Ansi Segment - no data available')
            }
        } else {
            this.$router.push({name: 'Login'})
        }
    },
    setAnsiSegmentsHistory(rows, row) {
        if (!rows || !rows.length) return
        if (!row || !row.selected_item || row.selected_item.ansi_id == null) return

        this.ansiSegments = rows.sort((a,b) => {
            if (a.region < b.region) return -1;
            if (a.region > b.region) return 1;
            return a.ansi_id - b.ansi_id;
        })

        let index = this.ansiSegments.findIndex((seg) => seg.ansi_id === row.selected_item.ansi_id)

        if (index === -1) return

        if (this.currentSegmentIndex && this.currentSegmentIndex != index) {
            sessionStorage.setItem('prevAnsiSegment', JSON.stringify(this.ansiSegments[this.currentSegmentIndex]))
        }

        this.currentSegmentIndex = index
    },
    hasPrevAnsiSegment() {
        return sessionStorage.prevAnsiSegment ? true : false
    },
    lastANSISegment() {
        let segment = JSON.parse(sessionStorage.getItem('prevAnsiSegment'))

        let newIndex = this.ansiSegments.findIndex((seg) => segment.ansi_id == seg.ansi_id)

        this.saveEndTimeForAnsi(this.ansiSegments[this.currentSegmentIndex])
        this.saveStartTimeForAnsi(this.ansiSegments[newIndex])

        // Get coords for prev segment
        let x  = segment.x
        let y  = segment.y

        this.$emit('ansiSegmentChange', [x, y])
        this.$emit('setSpeedLimit', this.ansiSegments[newIndex])

        sessionStorage.setItem('prevAnsiSegment', JSON.stringify(this.ansiSegments[this.currentSegmentIndex]))

        this.updateCurrentIndex(segment)
    },
    updateCurrentIndex(segment) {
        this.currentSegmentIndex = this.ansiSegments.findIndex((seg) => seg.ansi_id === segment.ansi_id)
    },
    setCustomerShortcuts() {
        switch (this.customerProjectId) {
            case '22': 
                // customerProjectId = 22 -- GM ANSI
                this.btnLabels = ['Lane', 'Marker', 'Xing', 'Prima', 'Speed']
                this.btnLayers = {
                    'Lane': ['Lane'],
                    'Marker': ['Marker', 'Barriers', 'Edges'],
                    'Xing': ['Crossings', 'Signs', 'Objects', 'intersections', 'ANSI', 'Light to Lane'],
                    'Prima': ['Primary', 'Secondary'],
                    'Speed': ['Speed Signs', 'Otonomo']
                }
                break;
            case '29':
                // customerProjectId = 29 -- Rivian UDBX2 ANSI
                this.btnLabels = ['Seg', 'LN PT', 'Edge', 'Xing', 'Speed']
                this.btnLayers = {
                    'Seg': ['lanes', 'road_segments'],
                    'LN PT': ['lane_lines', 'lane_line_points', 'lane_line_attributes'],
                    'Edge': ['edges', 'edge_attributes', 'road_edge_points'],
                    'Xing': ['lane_attributes', 'functional_authority'],
                    'Speed': ['Speed Signs']
                }
                break;
            case '5':
                // customerProjectId = 5 -- Nissan ANSI
                this.btnLabels = ['Seg', 'LNPT', 'Edge', 'Xing', 'Speed']
                this.btnLayers = {
                    'Seg': ['lanes', 'road_segments'],
                    'LNPT': ['lane_lines', 'lane_line_points', 'lane_line_attributes'],
                    'Edge': ['edges', 'edge_attributes', 'road_edge_points'],
                    'Xing': ['lane_attributes', 'regulatory_traffic_device', 'pavement_markings_conn', 'functional_authority'],
                    'Speed': ['signs']
                }
                break;
            case '23':
                // customerProjectId = 23 -- Subaru ANSI
                this.btnLabels = ['Seg', 'LNPT', 'Edge', 'Xing', 'Speed']
                this.btnLayers = {
                    'Seg': ['lanes', 'road_segments'],
                    'LNPT': ['lane_lines', 'lane_line_points', 'lane_line_attributes'],
                    'Edge': ['edges', 'edge_attributes', 'road_edge_points'],
                    'Xing': ['lane_attributes', 'regulatory_traffic_device', 'functional_authority'],
                    'Speed': ['signs']
                }
                break;
            case '4':
                // customerProjectId = 4 -- Rivian ANSI
                this.btnLabels = ['Seg', 'Lane', 'Del', 'Point', 'Xing', 'Speed', 'ANSI']
                this.btnLayers = {
                    'Seg': ['road_segments'],
                    'Lane': ['drive_lane_subtype', 'lane_ends'],
                    'Del': ['lane_line_delineator', 'road_edge_delineator', 'lane_shoulder_delineator'],
                    'Point': ['merge_context_features', 'mandatory_point_feature', 'optional_point_feature', 'merge_point_feature', 'split_point_feature'],
                    'Xing': ['overhead_surface_point_feature', 'connection_segments', 'unsafe_stretches_starts', 'unsafe_stretches_ends'],
                    'Speed': ['max_speed_limits', 'Otonomo'],
                    'ANSI': ['ANSI']
                }
                break;
            case '24':
                // customerProjectId = 4 -- Rivian ANSI
                this.btnLabels = ['Seg', 'LNPT', 'Edge', 'Xing', 'Speed']
                this.btnLayers = {
                    'Seg': ['Lanes', 'Road Segments'],
                    'LNPT': ['Lane Lines', 'Lane Line Points', 'Lane Line Attributes'],
                    'Edge': ['Road Edges', 'Road Edge Attributes', 'Road Edge Points'],
                    'Xing': ['Lane Attributes', 'RTD_Applied_Position', 'Functional Authority'],
                    'Speed': ['Signs']
                }
                break;
            case '34':
                // customerProjectId = 4 -- Rivian ANSI
                this.btnLabels = ['Seg', 'LNPT', 'Edge', 'Xing', 'Speed']
                this.btnLayers = {
                    'Seg': ['Lanes', 'Road Segments'],
                    'LNPT': ['Lane Lines', 'Lane Line Points', 'Lane Line Attributes'],
                    'Edge': ['Road Edges', 'Road Edge Attributes', 'Road Edge Points'],
                    'Xing': ['Lane Attributes', 'RTD_Applied_Position', 'Functional Authority'],
                    'Speed': ['Signs']
                }
                break;
        }
    },
    getSegmentLabelClass() {
        let retVal

        if (this.btnLabels.length == 0 || this.layerDefinition == 'BIASED') {
            retVal = 'segment-label-window small'
        } else if (this.customerProjectId == '4') {
            retVal = 'segment-label-window wide'
        } else {
            retVal = 'segment-label-window medium'
        } 

        return retVal
    } 
  },
  watch: {
    currentSegmentIndex: function(newValue) {
        if (newValue <= 0) {
            this.isPrevDisabled = true
            this.isNextDisabled = false
        } else if (newValue == this.ansiSegments.length - 1) {
            this.isNextDisabled = true
            this.isPrevDisabled = false
        } else {
            this.isNextDisabled = false
            this.isPrevDisabled = false
        }
    },
    customerProjectId: function(newValue) {
        this.setCustomerShortcuts()
    }
  },
  created() {
    this.setCustomerShortcuts()
    if (sessionStorage.prevAnsiSegment) {
        sessionStorage.removeItem('prevAnsiSegment')
    }
  }
}
</script>

<style scoped>
.small {
    left: -27px;
    top: 50px;
}
.medium {
    left: 90px;
    top: 50px;
}
.wide {
    left: 135px;
    top: 50px;
}
.segment-label-window {
    height: 20px;
    width: 170px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background: rgba(6, 60, 109, 0.85); */
    background: #eef3f9;
    color: #063c6d;
    position: absolute;
    border-radius: 0.25rem;
    font-size: 13px;
    font-weight: 900;
    padding-top: 1px;
}
.navigation-window {
    position: relative;
    height: 45px;
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 10px;
    padding-right: 10px;
    border: 1px solid rgba(6, 60, 109, 0.12);
    border-radius: 0.25rem;
    background: #eef3f9;
    color: #063c6d;
    line-height: 1.25;
    box-shadow: 0 2px 8px rgba(6, 60, 109, 0.12);
}
.icons {
    width: 100%;
    height: 90%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 15px;
}
.prev, .next, .last {
    color: rgba(6, 60, 109, 1);
    transition: color 0.15s;
}
.next:hover, .prev:hover, .last:hover {
    color: #063c6d;
    cursor: pointer;
}
.disabled {
    pointer-events: none;
    opacity: 0.4;
}
.fa-1-5x {
    font-size: 1.5em;
}
</style>